
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('~/bootstrap');

window.Vue = require('vue').default;
require('vue-axios-interceptors');
window.axios = require('axios');
window.axios.interceptors.response.use(
    function (response) {
        return response;
    }, function (error) {
        if (error.response.status === 403) {
            Vue.prototype.$eventBus.$emit('unauthorised', true);
        } else {
            return Promise.reject(error);
        }
    }
);
Vue.prototype.$eventBus = new Vue();

//System Imports
import VueRouter from "vue-router";
import XDS from "@hyperionx/xds";
import VueClip from "vue-clip";
import VueScrollTo from 'vue-scrollto';
import VueAnalytics from 'vue-ua';
import IdleVue from "idle-vue";

Vue.use(VueRouter);
Vue.use(VueScrollTo);
Vue.use(VueClip);
Vue.use(XDS, {
    theme: {
        primary: '#173F35',
        secondary: '#FFBF3F',
        accent: '#00E09E',
        error: '#DC000F',
        info: '#4A9DD1',
        success: '#0DA20D',
        warning: '#FAAA00',
        cancel: '#E1E4EB',
        red: '#FF585F',
        orange: '#FFA700',
        yellow: '#FFCE00',
        green: '#52C76B',
        teal: '#00F8D2',
        blue: '#0777FF',
        pistachio: '#E0EC89',
        offwhite: '#F6F6F6'
    },
    iconfont: "fa"
});

import Default from '~/layouts/Default.vue';
import Login from '~/layouts/Login.vue';
import Standard from "./layouts/Standard";
import Broker from "./layouts/Broker";
import Insured from "./layouts/Insured";

Vue.component('app', require('~/App.vue').default);

// Layouts
Vue.component('default-layout', Default);
Vue.component('standard-layout', Standard);
Vue.component('login-layout', Login);
Vue.component('broker-layout', Broker)
Vue.component('insured-layout', Insured)

//Components
Vue.component('loading-spinner', require('~/components/Shared/UIComponents/LoadingSpinner').default);
Vue.component('field-group', require('~/components/Shared/UIComponents/FieldGroup').default);
Vue.component('question-section', require('~/components/Shared/UIComponents/QuestionSection').default);
Vue.component('x-currency-text-field', require('~/../../../packages/HyperionX/UIComponents/XCurrencyTextField').default);
Vue.component('error-messages', require('~/components/Shared/Interceptors/ErrorMessages').default);


import moment from "moment";
Vue.prototype.$moment = moment;

// Load up filters
import filters from '~/filters/filters';
Vue.use(filters);

// Routes
import routes from '~/routes/routes';
let router = new VueRouter({
    mode: 'history',
    routes,
});

// Setup Google Analytics
Vue.use(VueAnalytics, {
    appName: 'Tepfin X',
    appVersion: '1.0.0',
    trackingId: 'UA-151752887-8',
    vueRouter: router,
    trackPage: true,
});

Vue.use(IdleVue, {
    eventEmitter: Vue.prototype.$eventBus,
    //25 minutes
    idleTime: 1000 * 60 * 25,
    startAtIdle: false
});

const data = {
    info: {},
    user: {},
    scopes: [],
    role: '',
    notifications: null,
    jobRoles: [],
    policy: {
        currency_code: null
    }
};

//Setup auth service
import { HyperionAuth } from "@hyperionx/hyperion-x-auth";
Vue.prototype.$hyperionAuth = new HyperionAuth();

router.beforeEach(async (to, from, next) => {
    await router.app.$hyperionAuth.initialize();

    const routeScopes = to.meta.scopes;

    if (!app.hasOwnProperty('user') || !app.user.hasOwnProperty('permissions')) {
        if (!['login'].includes(to.name)) {
            await app.loadData();
        }
    }

    // Unprotected route
    if (typeof routeScopes === 'undefined') {
        return next();
    }

    // Access all Scope
    routeScopes.push('*');

    // Get user scopes
    const userScopes = router.app.$hyperionAuth.getUserScopes();
    const hasAccess = routeScopes.filter(routeScope => userScopes.includes(routeScope)).length > 0;

    if (hasAccess) {
        return next();
    }

    next({ path: '/unauthorised' })
});


const app = new Vue({
    el: '#application',
    router,
    data: data,
    async created() {
        await this.$hyperionAuth.initialiseEnvironment(this.unauthenticated, this.unauthorised, this.redirectionToUpdateExpiredPassword);

        if (localStorage.getItem('hyx-auth') && this.$router.currentRoute.name !== 'login') {
            this.loadData()
        }
    },
    watch:{
        $route (to, from) {
            this.setPolicyData('currency_code', '');
        }
    },
    methods: {
        unauthenticated() {
            this.$router.push('/login');
        },
        unauthorised() {
            this.$router.push('/unauthorised');
        },
        redirectionToUpdateExpiredPassword(redirectTo) {
            this.$router.push({ name: redirectTo });
        },
        async loadData() {
            this.$root.user = (await axios.get(this.$root.api('user'), { responseType: 'json' })).data;
        },
        api(path) {
            console.log("API: " + path + " ==> " + this.$hyperionAuth.getEnvironment()['MIX_APP_API_DOMAIN'] + path);
            return this.$hyperionAuth.getEnvironment()['MIX_APP_API_DOMAIN'] + path;
        },
        env(key) {
            return this.$hyperionAuth.getEnvironment()[key];
        },
        userIsSuperUser() {
            return this.$root.user.role.id === 1 && this.$root.user.role.name === "user";
        },
        userCan(permissionName) {
            return this.$root.hasOwnProperty('user') && this.$root.user.hasOwnProperty('permissions') && Boolean(this.$root.user.permissions.find(permission => permission.name === permissionName));
        },
        isBrokerUser() {
            return this.$root.hasOwnProperty('user') && this.$root.user.company.company_type === 'broker';
        },
        isInsuredUser() {
            return this.$root.hasOwnProperty('user') && this.$root.user.company.company_type === 'insured';
        },
        userCompanyType() {
            return this.$root.user.company.company_type;
        },
        setPolicyData(varName, value) {
            this.$root.policy[varName] = value;
        },
        getPolicyData(varName) {
            return this.$root.policy[varName];
        }
    }
});

/**
 * Add uuid id library for generating unique ids on the frontend.
 */
Vue.prototype.$uuid = require('uuid/v4');

//Expose for debug
window.app = app;
